import React from "react";
import Header from "../../components/Header";
import "./About.css";
import "bootstrap/dist/css/bootstrap.min.css";

import sarahImg from "../../assets/Cohens Family.png";
import roniImg from "../../assets/Roni.png";
import danielImg from "../../assets/Meir.png";
import MeirImg from "../../assets/Oppenheimer Family.png";

export default function AboutUs() {
    return (
        <div className="container-fluid min-vh-100 p-0" style={{ backgroundSize: "cover", fontFamily: "Inter, Arial, sans-serif" }}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <div className="aboutus-main-card bg-white rounded-4 shadow p-4 p-md-5 mx-auto" style={{ background: "rgba(255,255,255,0.97)" }}>
                            <div className="text-center mb-5">
                                <h1 style={{ color: "#15316b", fontWeight: 800, fontSize: "3rem", marginBottom: 24, letterSpacing: 1 }}>About Us</h1>
                                <div style={{ fontWeight: 700, fontSize: "1.3rem", marginBottom: 32 }}>
                                    Join a welcoming worldwide community that brings people together through sharing Friday night dinners.
                                </div>
                            </div>
                            <div className="row align-items-center mb-5 g-4">
                                <div className="col-12 col-lg-6 d-flex justify-content-center">
                                    <img
                                        src="https://images.pexels.com/photos/3184183/pexels-photo-3184183.jpeg"
                                        alt="People at dinner"
                                        className="img-fluid rounded-3 shadow"
                                        style={{ maxWidth: 300, height: "auto", objectFit: "cover" }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <h2 className="text-center text-lg-start" style={{ color: "#15316b", fontSize: "2rem", fontWeight: 700, marginBottom: 16 }}>What We Do</h2>
                                    <div style={{ fontWeight: 400, color: "#222", fontSize: "1.2rem", lineHeight: 1.6, textAlign: "left" }}>
                                        We connect individuals around the globe with Shabbat hosts and guests. Whether you’re travelling or living abroad, our platform offers a chance to experience the warmth of Shabbat in a friendly, hospitable atmosphere.
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 mt-4">
                                <h2
                                    className="text-center mb-4"
                                    style={{
                                        color: "#15316b",
                                        fontSize: "2rem",
                                        fontWeight: 700,
                                        letterSpacing: 1
                                    }}
                                >
                                    What Our Users Say
                                </h2>
                                <div className="row justify-content-center g-4">
                                    {[
                                        {
                                            img: sarahImg,
                                            name: "Sarah, USA",
                                            text: "I loved meeting new people from different cultures and sharing Shabbat together."
                                        },
                                        {
                                            img: roniImg,
                                            name: "Roni, Italy",
                                            text: "The hosts were so kind and welcoming. It felt like home away from home."
                                        },
                                        {
                                            img: danielImg,
                                            name: "Daniel, France",
                                            text: "Shabbat Abroad truly creates a sense of community. Highly recommend!"
                                        },
                                        {
                                            img: MeirImg,
                                            name: "Cohen Family, Israel",
                                            text: "It was so fun getting to know new people over Shabbat dinner."
                                        }
                                    ].map((t, i) => (
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center" key={i}>
                                            <div
                                                className="aboutus-testimonial bg-white rounded-3 shadow-sm p-3 d-flex flex-column align-items-center text-center"
                                                style={{
                                                    minWidth: 180,
                                                    maxWidth: 240,
                                                    gap: 16
                                                }}
                                            >
                                                <img
                                                    src={t.img}
                                                    alt={t.name}
                                                    className="aboutus-user-img mb-2"
                                                    style={{
                                                        width: 70,
                                                        height: 70,
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                        border: "2px solid #ffb97a"
                                                    }}
                                                />
                                                <strong style={{ color: "#15316b", fontSize: "1.1rem", marginBottom: 8 }}>{t.name}</strong>
                                                <div style={{ color: "#444", fontSize: "1rem", fontStyle: "italic" }}>{t.text}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}